import {Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges} from '@angular/core';
import {CoreComponent} from "../../../core/component/core-component/core.component";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {Router} from "@angular/router";
import {SignUpService} from "../../service/sign-up.service";
import {RegistrationApiService} from "../../api/registration-api.service";
import {ApiResponseDto} from "../../../core/interfaces/core.types";
import {OtpData} from "../../../core/component/otp/data/otp-data";


@Component({
  selector: 'rg-registration-otp',
  templateUrl: './registration-otp.component.html',
  styleUrls: ['./registration-otp.component.css']
})
export class RegistrationOtpComponent extends CoreComponent {

  constructor(protected formBuilder: FormBuilder,
              protected router: Router,
              protected registrationService: RegistrationApiService,
              protected signUpService: SignUpService,) {
    super();
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.initComponent();
  }

  /**
   * Initialize Component.
   */
  initComponent() {
    this.refreshComponent();
  }

  /**
   * Refresh Component.
   */
  refreshComponent() {
    this.initialized = true;
  }

  handleConfirmOtp(event: OtpData) {
    const phoneNumber = event.anyUserText;

    //verify registration-otp
    if (phoneNumber) {
      this.registrationService.confirmOtp(phoneNumber, event.otp as string).subscribe(res => {

        this.signUpService.registrationForm = res.form;
        this.signUpService.signatures = res.signatures;
        this.signUpService.registrationGuid = res.registrationGuid;

        this.router.navigate(['/registration']);

      }, error => {

        if (event.onError) {
          event.onError(error.error.data);
        }

      })
    }
  }

  handleRequestOtp(event: OtpData) {
    this.registrationService.requestOtp(event.anyUserText as string).subscribe(res => {

      if (event.onSuccess) {
        event.onSuccess(res.data);
      }

    }, error => {
      if (event.onError) {
        event.onError(error.error.data);
      }
    });
  }


}
